module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated efficiency"
  }, [_c('OrderTable', {
    key: 'order-table-orders',
    attrs: {
      "title": ("" + (_vm.$t('pages.orders'))),
      "headColumns": _vm.headColumns,
      "footColumns": _vm.footColumns,
      "rows": _vm.rows,
      "disableActionBTN": false,
      "isLoading": _vm.loading
    },
    on: {
      "addReceipt": _vm.addReceipt,
      "changeVal": _vm.changeVal,
      "download": _vm.download,
      "downloadAll": _vm.downloadAll,
      "deleteChange": _vm.deleteChange,
      "uploadImage": _vm.uploadImage
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6858d21e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/Orders.vue
// module id = 569
// module chunks = 0